var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "choiceGood", attrs: { id: "page_Container" } },
    [
      _c("div", { staticClass: "page" }, [
        _c(
          "div",
          { staticClass: "main-container", attrs: { id: "main-container" } },
          [
            _c(
              "div",
              { staticClass: "choiceGoods" },
              [
                _c(
                  "van-checkbox-group",
                  {
                    on: { change: _vm.changeItem },
                    model: {
                      value: _vm.result,
                      callback: function($$v) {
                        _vm.result = $$v
                      },
                      expression: "result"
                    }
                  },
                  _vm._l(_vm.dataRefund.memberOrderItemList, function(item) {
                    return _c(
                      "van-checkbox",
                      {
                        key: item.id,
                        staticStyle: { padding: "12px 0" },
                        attrs: {
                          name: item.id,
                          disabled: !item.retreatQuantity
                        }
                      },
                      [
                        _c("van-card", {
                          attrs: {
                            num: item.quantity,
                            desc: item.specificationValue,
                            title: item.productName,
                            thumb: item.productImg
                          }
                        })
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "submitBtn" },
          [
            _c(
              "van-button",
              {
                attrs: { round: "", type: "danger" },
                on: { click: _vm.submitBtn }
              },
              [_vm._v("提交")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }